<template>
	<div class="col-12 p-1 p-md-0 rounded background-white top-slider box-shadow d-md-flex mb-n4 box-menu">
		<div class="col-12 col-lg-12 col-md-12 p-0 mt-1 mt-md-0 mb-1 p-md-3 font-size-12">
			<div class="col-12 col-md-12">
				<div class="menu-container" @mouseover="mouseOver">
					<div class="navigation">
						<ul class="cf">
							<li>
								<router-link :to="{ name: 'dashboard' }" class="text-gray">
									<img src="assets/menu/menu_dashboard.png" class="img-fluid">
									<div class="font-size-sm-9 pt-1">Dashboard</div>
								</router-link>
							</li>
							<li>
								<router-link :to="{ name: 'stock' }" class="text-gray">
									<img src="assets/menu/menu_icon.png">
									<div class="font-size-sm-9 pt-1">Stok</div>
								</router-link>
							</li>
							<li>
								<router-link :to="{ name: 'transaction' }" class="text-gray">
									<span><img src="assets/menu/menu_transaksi.png"></span>
									<span class="badge background-red color-white rounded-pill transaction-badge mt-n1 ml-n1">{{profile.total_paid > 0 ? profile.total_paid : ''}}</span>
									<div class="font-size-sm-9 pt-1">Transaksi</div>
								</router-link>
							</li>
							<li>
								<router-link :to="{ name: 'ewallet' }" class="text-gray">
									<img src="assets/menu/menu_transaksi.png">
									<div class="font-size-sm-9 pt-1">Dana Penjualan</div>
								</router-link>
							</li>
							<li>
								<a class="text-gray menu-dropdown" href="javascript::;" :class="[$route.path== '/profile' || $route.path== '/courier' ? 'exact-active active' : '']">
									<img src="assets/menu/menu_pengaturan.png">
									<div class="font-size-sm-9 pt-1">Pengaturan</div>
								</a>
								<ul class="wrapit rounded box-shadow">
									<li>
										<router-link :to="{ name: 'profile' }" class="text-left text-gray font-size-sm-9 pt-3 d-flex">
											<div class="col-4 pl-0">
												<img src="assets/menu/user-regular.png" alt="" class="icon-menu-profile mt-n1">
											</div>
											Profil
										</router-link>
									</li>
									<li>
										<router-link :to="{ name: 'courier' }" class="text-left text-gray font-size-sm-9 pt-2 pb-3 d-flex">
											<div class="col-4 pl-0">
												<img src="assets/menu/delivery-truck.png" alt="" class="icon-menu-courier mt-n1">
											</div>
											Kurir
										</router-link>
									</li>
								</ul>
							</li>
							<li>
								<router-link to="/auth/login" class="text-gray" v-on:click.native="loginSso()">
									<img src="assets/menu/shop.png" class="img-fluid">
									<div class="font-size-sm-9 pt-1">Login POS</div>
								</router-link>
							</li>
							<li>
								<router-link to="/auth/login" v-on:click.native="onLogout()" class="text-gray">
									<img src="assets/menu/menu_keluar.png">
									<div class="font-size-sm-9 pt-1">Keluar</div>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapState, createNamespacedHelpers } from 'vuex';
	import $ from 'jquery';

	const { mapActions } = createNamespacedHelpers('auth');

	export default {
		name: 'MlMenu',
		data: () =>({
			settDrop: false
		}),
		
		methods: {
			...mapActions(['logout', 'getTokenSso']),

			loginSso() {
				this.getTokenSso().then(res => {
					window.open(res.url)
				})
			},
			onLogout() {
				this.logout().then(() => {
					this.$router.push({ name: 'login' });
				});
			},
			mouseOver: function(){
				$(".wrapit").css("left", function() {
					return $(this).parent().position().left;
				});
			}
		},
		computed: {
			...mapGetters('auth', ['isAuth']),
			...mapState('profileList', ['profile']),
		},
	}
</script>

<style scoped>
.dropdown-menu {
	transform: translate3d(4px, 49px, 0px) !important;
}

@media (min-width: 320px) and (max-width: 400px) {
	.dropdown-menu {
		transform: translate3d(4px, 37px, 0px) !important;
	}
}
.color-white {
    color: #fff!important;
}
.transaction-badge {
	position: relative !important;
	top: -6px;
	left: 4px;
}
</style>